/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    var ImageCarousel = /** @class */ (function () {
        function ImageCarousel(config) {
            this.mainSelector = config.mainSelector;
            this.thumbsSelector = config.thumbSelector;
        }
        ImageCarousel.prototype.run = function () {
            var mainParams = {
                spaceBetween: 16,
                slidesPerView: 4,
                //freeMode: true,
                //loopedSlides: 4,
                loop: false,
                //observer: true,
                //observeParents: true,
                //watchSlidesVisibility: true,
                watchSlidesProgress: true,
            };
            var mainSwiper = new swiper.Swiper(this.thumbsSelector, mainParams);
            var thumbParams = {
                spaceBetween: 18,
                //observer: true,
                //observeParents: true,
                loopedSlides: 4,
                loop: false,
                slidesPerView: 'auto',
                //navigation: {
                //	nextEl: ".swiper-button-next",
                //	prevEl: ".swiper-button-prev",
                //},
                thumbs: {
                    swiper: mainSwiper,
                },
            };
            new swiper.Swiper(this.mainSelector, thumbParams);
        };
        return ImageCarousel;
    }());
    MoyaComponents.register('ecar.carousel', [
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
        'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
    ], function (el) {
        var config = {
            mainContainer: el,
            mainSelector: el.dataset.mainSelector,
            thumbSelector: el.dataset.thumbSelector,
        };
        var carousel = new ImageCarousel(config);
        carousel.run();
    });

}(window));
typeof tsBuild === 'function' && tsBuild();})();
